import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { forwardRef as d } from "react";
const m = ({
  title: v,
  titleId: e,
  ...f
}, i) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: i, "aria-labelledby": e, ...f, children: [
  v ? /* @__PURE__ */ l("title", { id: e, children: v }) : null,
  /* @__PURE__ */ l("path", { fill: "#fff", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10" }),
  /* @__PURE__ */ l("path", { fill: "#f0b90b", fillRule: "evenodd", d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m-.048-19.984-4.227 2.46 1.554.91 2.673-1.552 2.673 1.551 1.554-.909zm2.673 4.655 1.554.909v1.817l-2.673 1.552v3.103l-1.554.909-1.554-.909v-3.103l-2.673-1.552V9.58L9.28 8.67l2.673 1.552zm0 4.92 1.554-.909v1.819l-1.554.908zm-.015 3.104 2.673-1.552V12.04l1.554-.909v4.921l-4.227 2.46zm2.673-7.758-1.554-.91 1.554-.908 1.554.909v1.818l-1.554.909zM10.398 19.17v-1.818l1.554.909 1.554-.91v1.819l-1.554.909zM9.28 15.409 7.725 14.5v-1.818l1.554.91zm2.673-6.472-1.554-.91 1.554-.908 1.554.909zm-3.776-.91-1.554.91v1.818l-1.554-.91V8.029l1.554-.909zm-3.108 3.104 1.554.909v3.103l2.673 1.552v1.817l-4.227-2.46z", clipRule: "evenodd" })
] }), n = d(m);
export {
  n as default
};
//# sourceMappingURL=bsc.js.map
